/**
 * Performance Indicator Service - Fetch performance indicators from API
 */

import { apiRequest } from '../config/api.js'
import { handleApiError } from './errorHandler.js'

/**
 * Get performance indicators, optionally filtered by role
 * @param {string} [role] - 'rdn', 'ndtr', or 'all' (default: 'all')
 * @returns {Promise<Array>} Array of { id, code, description, for_rdn, for_ndtr }
 */
export async function getPerformanceIndicators(role = 'all') {
  try {
    const params = new URLSearchParams()
    if (role && role !== 'all') {
      params.set('role', role)
    } else {
      params.set('role', 'all')
    }
    const data = await apiRequest(`/performance_indicators?${params.toString()}`, {
      method: 'GET'
    })
    return Array.isArray(data) ? data : []
  } catch (error) {
    handleApiError(error)
    throw error
  }
}
